import { render, staticRenderFns } from "./BajasComercialesPantalla.vue?vue&type=template&id=3b704b24&"
import script from "./BajasComercialesPantalla.vue?vue&type=script&lang=ts&"
export * from "./BajasComercialesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports